import React from "react";
import { Brain, Shield, Lightbulb, Users } from "lucide-react";

const WhyUsSection = () => {
  const features = [
    {
      icon: <Brain className="feature-icon" />,
      title: "Pensamiento Crítico Primero",
      description: "Enseñamos a pensar, analizar y resolver problemas reales, no a memorizar."
    },
    {
      icon: <Shield className="feature-icon" />,
      title: "Ciberseguridad desde Pequeños",
      description: "Conciencia digital y hábitos seguros para navegar con confianza desde temprana edad."
    },
    {
      icon: <Lightbulb className="feature-icon" />,
      title: "Innovación Aplicada",
      description: "Proyectos reales que desarrollan creatividad, lógica y mentalidad emprendedora."
    },
    {
      icon: <Users className="feature-icon" />,
      title: "Confianza Parental",
      description: "Metodología probada. Seguimiento personalizado y avances claros para papás tranquilos."
    }
  ];

  return (
    <section className="why-us-section" id="why-us">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">
            No enseñamos materias, 
            <span className="title-highlight">
              {" "}entrenamos en habilidades que el futuro demanda
            </span>
          </h2>
          <p className="section-subtitle">
            Mientras otros enseñan código, nosotros formamos pensadores críticos 
            capaces de crear, resolver problemas y adaptarse a un mundo en constante cambio.
          </p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon-container">
                {feature.icon}
              </div>
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
              <div className="feature-glow"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyUsSection;
